import {inject, Injectable} from '@angular/core';
import {BaseService} from '../base.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})


export class LectionsService extends BaseService {

  getInfoLections(id: number) {
    return this.getById(`${environment.baseUrl}/service/webapi/v1/lessons/${id}`)
  }

  completeLection(lessonId: number) {
    /*const layout = this.token
      ? new HttpHeaders({
        Authorization: `Bearer ${this.token}`
      })
      : undefined;*/
    return this.http.post(`${environment.baseUrl}/service/webapi/v1/courseprogress/lessons/${lessonId}/complete`, null)
  }
}
